/* =========================================================================
   Place des Arts — Catalogue artistes (filtrage / tri / pagination cliente)
   -------------------------------------------------------------------------
   Vanilla JS. Source de données = index artistes sur le CDN (data-artists-url,
   metafield pda.artists_index, ~2789 artistes) ; repli sur l'index inline
   #pda-artists-index (≤250) si le CDN est indispo.

   Les cards sont RENDUES CÔTÉ CLIENT depuis l'index (plus de plafond 250 :
   l'ancien rendu SSR ne couvrait que 250 artistes). La 1re page de 48 reste en
   SSR (crawl / LCP / no-JS) puis le JS rebâtit la grille depuis l'index.

   DESIGN 3B (Phase 5) : le CHROME (sidebar ouvrir/fermer, dropdowns de quick-pills,
   Échap/clic-extérieur) est géré par pda-facets.js — partagé avec le catalogue
   œuvres. Ce module ne fait QUE la donnée : hydrate les [data-pda-facet-body] en
   markup checkbox 3B, filtre/trie/pagine, recherche-dans-facette, état URL.

   État : { letter, facets:{nationality,movement,style,techniques,badge}, sort, page }
   Synchronisé avec l'URL (?lettre=M&mouvement=...&tri=alpha-desc), restauré au chargement.
   (L'exemple portait `tri=za` : clé MORTE depuis FIX-5, traduite par alias, plus jamais écrite.)
   Filtrage = intersection de toutes les contraintes actives.
   Tri (FIX-5, 12/08) : les 6 options du BACK-OFFICE — les CLÉS viennent de
   `CatalogueArtistesView.tsx`, les libellés aussi SAUF `ajout-desc`, qui s'affiche
   « Nouveautés » ici et « Ajout récents » au BO (arbitrage Sam du 12/08 : la vitrine
   parle d'une seule voix, le catalogue ŒUVRES dit déjà « Nouveautés »). Ne pas
   « rétablir la parité » sur ce mot — c'est une divergence VOULUE.
   Alphabétique A→Z / Z→A sur le NOM DE FAMILLE (champ
   `nom`, repli dernier mot), Nouveautés / Ajout anciens (`added`, départagé par `oid` —
   sans lui 1 130 artistes sur 1 132 sont ex æquo à la seconde), Naissance récente /
   ancienne. « Plus d'œuvres » est RETIRÉE : elle triait vraiment, mais n'avait aucune
   contrepartie au BO. Défaut vitrine = alphabétique (le BO, lui, ouvre sur Ajout récents).
   ========================================================================= */
(function () {
  'use strict';

  var DEFAULT_PAGE_SIZE = 48;
  /* S05 lot E3.e (07/08) — LES GROUPES D'ARTISTES DEVIENNENT AUTOMATIQUES.
   *
   * Contrat Sam : « Artiste badge doit fonctionner comme un TAG grâce au
   * metaobject » — ajouter une valeur de badge dans le BO fait apparaître un
   * groupe PARTOUT, sans toucher au code.
   *
   * L'architecture est le DÉCALQUE EXACT de celle des œuvres (cote Sam :
   * « même chose qu'avec oeuvre d'exception ») :
   *   · `badge`      = LE badge à part → booléen dédié + toggle propre, comme
   *                    « Pièce d'exception » a son champ `ex` ;
   *   · `collection` = TOUS LES AUTRES badges → liste à cocher intitulée
   *                    « Collection », comme la facette « Collection » des
   *                    œuvres liste les tags. Le badge à part en est EXCLU,
   *                    exactement comme le tag d'exception est exclu du dict.
   *
   * ⛔ `collection` n'est pas une clé de l'index : sa donnée est `a.badges`,
   * filtrée (cf. `autresBadges`). D'où `SOURCE_KEY`. */
  var FACET_KEYS = ['nationality', 'movement', 'style', 'techniques', 'badge', 'collection'];
  // Facettes rendues en checklist (sidebar + quick-pills) ; `badge` = toggle à part.
  var LIST_KEYS = ['nationality', 'movement', 'style', 'techniques', 'collection'];
  /* Clé de facette → clé de l'index qui porte sa donnée. Absente = identité. */
  var SOURCE_KEY = { collection: 'badges' };
  /* LE badge à part, par son HANDLE.
   * ⚠️ JUMEAUX : `app/lib/pda/index-build/artistes-index.ts` (BADGE_A_PART) et
   * `snippets/pda-artists-index.liquid`. Les trois portent la même valeur et
   * changent au même commit — rien ne les relie automatiquement.
   * ⛔ UN HANDLE, PAS UN LIBELLÉ : Sam a renommé ce badge au pluriel le 07/08 ;
   * un test par nom serait déjà faux. */
  var BADGE_A_PART = 'artiste-celebre';

  /* Les badges d'un artiste HORS badge à part — la donnée de la facette
   * « Collection ».
   *
   * ⛔ SI `badgeHandles` MANQUE, ON NE REND RIEN. C'est le cas du SKEW DE
   * DÉPLOIEMENT : un index publié avant le lot E3.e porte `badges` mais pas
   * `badgeHandles`, donc plus aucun moyen de distinguer le badge à part des
   * autres. Le laisser passer afficherait « Artistes célèbres » DEUX fois — en
   * toggle et dans la liste. Mieux vaut une facette vide (donc masquée) qu'un
   * doublon : faux et visible plutôt que faux et crédible. */
  function autresBadges(a) {
    var noms = a.badges || [];
    var handles = a.badgeHandles;
    if (!handles || handles.length !== noms.length) return [];
    var out = [];
    for (var i = 0; i < noms.length; i++) {
      if (handles[i] !== BADGE_A_PART) out.push(noms[i]);
    }
    return out;
  }

  var CHECK_SVG =
    '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark"><path d="M4.75439 10.7485L7.68601 14.5888C7.79288 14.7288 7.84632 14.7988 7.91174 14.8242C7.96907 14.8466 8.03262 14.8469 8.09022 14.8253C8.15596 14.8007 8.21026 14.7314 8.31886 14.5927L15.2475 5.74658" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ARROW_SVG =
    '<svg class="pda-card-artist__arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25H5.25C4.83579 3.25 4.5 3.58579 4.5 4C4.5 4.41421 4.83579 4.75 5.25 4.75H11.25V10.75C11.25 11.1642 11.5858 11.5 12 11.5C12.4142 11.5 12.75 11.1642 12.75 10.75V4ZM4 12L4.53033 12.5303L12.5303 4.53033L12 4L11.4697 3.46967L3.46967 11.4697L4 12Z" fill="currentColor"/></svg>';
  // × des chips — IDENTIQUE au catalogue œuvres (pda-catalog.js) pour un rendu pixel-identique.
  var CHIP_X_SVG =
    '<svg aria-hidden="true" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M1 1 7 7M7 1 1 7" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
  /* Titres de sélection « param:valeur » → libellé, émis par le Liquid depuis les
   * metaobjects (badge). ⛔ EN PORTÉE DE MODULE, PAS DANS `setup()` — c'est la règle
   * que ce fichier écrit lui-même 10 lignes plus bas, née d'un bug vécu : une table
   * `var` déclarée au milieu de `setup` vaut `undefined` pour tout lecteur situé plus
   * haut, silencieusement. Le commit du 20/08 a ajouté un SECOND lecteur (la chip du
   * toggle badge) ; sur `undefined` le repli ne joue pas, c'est un TypeError DUR qui
   * tue `render()` — donc la grille, les compteurs et les facettes, pas juste la chip. */
  var SELECTION_TITLES = {};

  /* Libellé des chips pour les facettes non-liste (toggle badge).
   * ⛔ GARDE DE STRUCTURE, PAS UN LIBELLÉ DE TRAVAIL — la source est
   * `SELECTION_TITLES['badge:oui']`, émis INCONDITIONNELLEMENT par le Liquid depuis
   * le metaobject `badge_artiste` : renommable au BO, et LOCALISÉ par Shopify hors fr
   * (le Liquid le retrouve par boucle `for` sur son handle). Cette constante ne peut
   * donc tirer que si le script JSON est absent ou illisible.
   * ⚠️ Elle porte du FRANÇAIS : le jour où elle tire sur /de, elle peindrait du FR en
   * silence. D'où le `console.warn` de `libelleBadgeAPart()` — on échoue FORT plutôt
   * que de mentir. Sam a déjà renommé ce badge au pluriel le 07/08 : un littéral tenu
   * pour référence se serait périmé ce jour-là, sans erreur. */
  var CHIP_LABELS = { badge: 'Artistes célèbres' };

  /* SOURCE UNIQUE du libellé du badge à part (titre de sélection ET chip).
   * Deux exemplaires du même repli, c'est deux endroits où oublier la localisation :
   * le H1 et la chip passent tous les deux par ici. Le warn ne s'émet qu'une fois —
   * cette fonction est appelée à chaque rendu. */
  var badgeReplitDejaSignale = false;
  function libelleBadgeAPart() {
    var v = SELECTION_TITLES['badge:oui'];
    if (v) return v;
    if (!badgeReplitDejaSignale) {
      badgeReplitDejaSignale = true;
      console.warn('[pda-artists-catalog] SELECTION_TITLES["badge:oui"] absent — repli sur le littéral FR CHIP_LABELS.badge. Le libellé du badge à part ne sera PAS localisé.');
    }
    return CHIP_LABELS.badge;
  }

  /* ⛔ EN PORTÉE DE MODULE, PAS DANS `setup()` — et ce n'est pas cosmétique.
   * Ces tables étaient déclarées en `var` au milieu de `setup`, alors que `filtrerTrisDispo`
   * est appelée bien plus haut dans la même fonction : `var` hoiste la DÉCLARATION, jamais
   * l'AFFECTATION. Au moment de l'appel elles valaient donc `undefined`, et le garde ne
   * pouvait pas fonctionner — silencieusement, sans même une erreur en console (la boucle
   * ne trouvait rien à parcourir avant de les toucher).
   * Mesuré : index sans `oid`, et les 2 options « Ajout » restaient offertes. */
  /* ⛔ DES `Set`, PAS DES OBJETS — parité avec `SORT_KEYS` de `pda-catalog.js`.
   * En objet nu, `TRIS_VALIDES[s]` est truthy pour toute clé HÉRITÉE d'Object.prototype
   * (`constructor`, `toString`, `valueOf`, `hasOwnProperty`…) : la « whitelist stricte
   * anti-forge » annoncée deux lignes plus bas n'en était pas une. Elle ne tenait que par
   * effet de bord — `ALIAS[s]` était truthy pour ces mêmes clés et réassignait `s` à une
   * fonction avant le test. Une validation qui dépend d'une ligne écrite pour autre chose
   * (la rétrocompat des vieux liens) n'est pas une validation, c'est une coïncidence. */
  var TRIS_VALIDES = new Set(['alpha-asc', 'alpha-desc', 'ajout-desc', 'ajout-asc',
                              'naissance-desc', 'naissance-asc']);
  var TRI_OID = new Set(['ajout-desc', 'ajout-asc']);
  /* ⛔ UNE SEULE SOURCE POUR LE TRI PAR DÉFAUT — quatre sites la consomment (état initial,
   * omission dans l'URL, reset au retour navigateur, repli quand `oid` manque). Elle est
   * une CONSTANTE et pas quatre littéraux parce que le renommage des clés du BO a déjà
   * cassé cet accord une fois : l'état initial était resté sur l'ancien `'az'`, plus aucune
   * option ne correspondait, et le menu n'affichait AUCUNE sélection au chargement — alors
   * que l'ordre à l'écran restait juste (le comparateur retombe sur l'alphabétique).
   * Défaut ALPHABÉTIQUE, volontairement ≠ du BO qui ouvre sur « Ajout récents » : la vitrine
   * doit rester lisible pour un visiteur, et `alpha-asc` ne dépend pas d'`oid`. */
  var TRI_DEFAUT = 'alpha-asc';
  /* Vrai quand l'index servi ne porte pas `oid` : les tris « Ajout » sont alors non seulement
   * RETIRÉS DU MENU, mais aussi REFUSÉS À LA LECTURE D'URL. Sans ce second verrou, un lien
   * `?tri=ajout-desc` (partagé, ou forgé) triait quand même — au hasard sur 1 130 artistes
   * sur 1 132. Masquer une option ne suffit pas : il faut aussi la rendre inatteignable. */
  var oidAbsent = false;

  var uid = 0;

  function normalize(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  /* ⛔ MÊME CLÉ QUE LE CATALOGUE ŒUVRES, PARCE QUE C'EST LE MÊME MOT SUR LE MÊME
   * ÉCRAN. Mesuré le 20/08 sur `/search?tab=artistes` : les DEUX moteurs y tournent
   * et la page porte DEUX boutons « Réinitialiser ». Tant que celui-ci restait un
   * littéral face au `trad()` de `pda-catalog.js`, la première traduction posée
   * aurait donné « Zurücksetzen » et « Réinitialiser » côte à côte.
   * ⚠️ Ce fichier n'est PAS migré (≈107 chaînes restantes) : seule cette clé-là est
   * câblée, parce qu'elle est la seule à être peinte AUSSI par l'autre moteur.
   * Chargé en `defer`, donc après le runtime posé en <head> ; le shim dégrade en
   * peignant la clé plutôt que de tuer le module. */
  const trad = (cle, params) =>
    (window.PDA && typeof window.PDA.t === 'function') ? window.PDA.t(cle, params) : cle;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; });
  }
  function escapeAttr(s) {
    return String(s == null ? '' : s).replace(/"/g, '&quot;');
  }
  /* ⛔ RACINE LOCALISÉE (fuite ④ du 24/08) : l'index artistes CDN embarque 2 804 url
   * racine (« /collections/<handle> ») construites en FRANÇAIS — un fichier statique
   * servi tel quel à toutes les locales. Préfixer AU RENDU (Shopify.routes.root :
   * « / » en fr, « /en/ » ailleurs) corrige les 2 804 liens pour toutes les langues
   * sans rebuild d'index. En fr le résultat est identique octet pour octet ; une url
   * déjà localisée ou externe est rendue telle quelle (garde anti double-préfixe). */
  var RACINE_LOCALE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function urlLocalisee(u) {
    if (!u || RACINE_LOCALE === '/') return u;
    var s = String(u);
    if (s.charAt(0) !== '/' || s.indexOf('//') === 0 || s.indexOf(RACINE_LOCALE) === 0) return s;
    return RACINE_LOCALE + s.slice(1);
  }

  /* ── IMAGES À LA TAILLE PEINTE (SEO 08, étape 3, 30/10) ─────────────────────
   * L'index sert l'ORIGINAL de chaque image (1 000 px de large). Mesuré le 30/10
   * sur la prod : 12 cartes, 1,8 Mio au premier écran à 390 px, pour des cases
   * de 174 px. Le CDN Shopify sait réduire l'image (`&width=`), mais la case la
   * recadre en `object-fit: cover` : une œuvre plus large que sa case est peinte
   * plus large que sa boîte (5 des 16 premières cartes). Le worker publie donc
   * les dimensions (`imgWH`, `portraitWH`) ; k = max(1, ratio de l'image / ratio
   * de la case) et la largeur demandée vaut celle de la case × k.
   * - Sans dimensions (index d'avant le worker) : l'original, comme avant.
   * - Pas de candidat au-delà de 720 px : plus large, le fichier redimensionné
   *   pèse souvent PLUS que l'original (16 cartes : 2 885 Kio en 960 px contre
   *   2 398 en original, mesuré le 30/10). L'original reste le dernier candidat.
   * - Cotes des cases : `pda-components.css`, `.pda-card-artist__media` (4/5) et
   *   `.pda-catcard__img` (5/4), vignette de 250 px et de 139 px sous 768
   *   (`.pda-catcard`). Les changer impose de changer ces constantes. */
  var LARGEURS_IMG = [240, 360, 480, 600, 720];
  var RATIO_CARTE = 4 / 5;
  var RATIO_VIGNETTE = 5 / 4;
  var VIGNETTE_D = 250, VIGNETTE_M = 139;
  function imageALaTaille(src, wh, ratioCase) {
    if (!src || !wh || !(wh[0] > 0) || !(wh[1] > 0)) return null;
    var sep = src.indexOf('?') === -1 ? '?' : '&';
    var candidats = [];
    for (var i = 0; i < LARGEURS_IMG.length; i++) {
      if (LARGEURS_IMG[i] < wh[0]) candidats.push(src + sep + 'width=' + LARGEURS_IMG[i] + ' ' + LARGEURS_IMG[i] + 'w');
    }
    candidats.push(src + ' ' + wh[0] + 'w');
    return { srcset: candidats.join(', '), k: Math.ceil(Math.max(1, (wh[0] / wh[1]) / ratioCase) * 100) / 100 };
  }
  /* Case pas encore mesurée : repli large (une colonne fait ~100vw sous 768),
   * corrigé par ajusterSizes() dans la même tâche, avant tout choix de fichier. */
  function sizesPour(largeurCase, k) {
    return largeurCase > 0
      ? Math.ceil(largeurCase * k) + 'px'
      : '(min-width: 768px) ' + Math.ceil(700 * k) + 'px, calc(100vw * ' + k + ')';
  }
  // Casse propre (sentence-case) : répare les libellés en minuscules de l'index CDN
  // (« lithographie » → « Lithographie ») sans toucher aux noms déjà capitalisés
  // ni majusculiser « de »/« la » (pas de title-case mot à mot).
  function prettyLabel(s) {
    s = String(s == null ? '' : s).trim();
    if (!s) return s;
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  /* LOT 4 (mécanisme D, 25/08) — LIBELLÉS LOCALISÉS DU CATALOGUE ARTISTES.
   * Deux sources, l'AFFICHAGE seul (les jetons d'URL et le filtrage restent sur les
   * valeurs FRANÇAISES de l'index — les deep-links du méga en dépendent) :
   *   · movement/style/techniques/collection(=badges) → la table du snippet GÉNÉRÉ
   *     pda-moteur-labels (mv/st/te/bd — mêmes NAMES que l'index, jonction exacte) ;
   *   · nationality → PDA.nationaliteAffichee (assets/pda-i18n.js) — SOURCE UNIQUE,
   *     déplacée là-bas le 25/08 quand la grille « Artistes similaires » a été mesurée
   *     rendant « France » en dur : le mécanisme (Intl.DisplayNames fr→ISO→locale,
   *     71 ISO + 5 alias + 3 manuels, registre en-GB) y vit désormais, à l'identique.
   *     pda-i18n.js est un defer du <head>, il précède toujours ce script (defer de
   *     section). Lookup raté ou runtime absent ⇒ FR rendu tel quel : visible au
   *     differ, jamais silencieusement faux. */
  var LABELS_LOC = null;
  (function () {
    var el = document.querySelector('[data-pda-moteur-labels]');
    if (el) { try { LABELS_LOC = JSON.parse(el.textContent); } catch (e) { LABELS_LOC = null; } }
  })();
  /* ⚠️ Résolution À L'APPEL, comme le shim `trad` plus haut — jamais une capture au
   * chargement : l'ordre defer <head> → defer de section tient aujourd'hui, mais un
   * futur `async` ou chargement dynamique aurait éteint la localisation EN SILENCE
   * (repli FR sans erreur). En FR, nationaliteAffichee rend null → labelLocalise rend
   * null → l'appelant garde le FR : identique à l'ancien NAT_AFFICHE === null. */
  var NAT_AFFICHE = function (nomFr) {
    return (window.PDA && typeof window.PDA.nationaliteAffichee === 'function')
      ? window.PDA.nationaliteAffichee(nomFr) : null;
  };
  /* ⛔ NE PAS AJOUTER `badge: 'bd'` ICI — « bd » ressemble à « badge », et c'est le piège.
   * Mesuré : la famille « bd » de `pda-moteur-labels` est une table valeur FR → libellé
   * localisé, dont les clés sont les NOMS des badges (« Artistes célèbres », « Artistes du
   * moment »). Elle est atteinte par la clé de facette `collection` = la checklist des
   * AUTRES badges, qui filtre bien sur ces noms.
   * La facette `badge`, elle, est un BOOLÉEN : sa seule valeur est le jeton `oui` (PARAM.badge
   * / readUrl), jamais un libellé. `labelLocalise('badge','oui')` chercherait donc `bd['oui']`
   * → toujours absent : l'entrée serait MORTE, tout en faisant croire au prochain lecteur que
   * le libellé du badge vient d'ici.
   * ⛔ Et ne pas créer de clé de locale `pda.facette.badge.label` (il n'en existe aucune,
   * vérifié) : les locales sont éditables depuis l'admin language editor, ce serait une
   * SECONDE source qui divergerait en silence au premier renommage du badge par Sam.
   * L'AUTORITÉ pour ce libellé est le nom du metaobject `badge_artiste`, traduit par Shopify
   * et servi par le Liquid → `SELECTION_TITLES['badge:oui']` → `libelleBadgeAPart()`. */
  var TABLE_PAR_FACETTE = { movement: 'mv', style: 'st', techniques: 'te', collection: 'bd' };
  function labelLocalise(key, v) {
    if (key === 'nationality' && NAT_AFFICHE) return NAT_AFFICHE(v);
    var t = TABLE_PAR_FACETTE[key];
    if (t && LABELS_LOC && LABELS_LOC[t] && Object.prototype.hasOwnProperty.call(LABELS_LOC[t], v) && LABELS_LOC[t][v]) return LABELS_LOC[t][v];
    return null;
  }

  // ── chargement de l'index : CDN (data-artists-url) → repli inline ──
  function init(root) {
    var inline = function () {
      var el = root.querySelector('#pda-artists-index');
      if (!el) return;
      try { setup(root, JSON.parse(el.textContent)); } catch (e) {}
    };

    var url = root.getAttribute('data-artists-url');
    if (url) {
      fetch(url)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (a) { if (Array.isArray(a) && a.length) setup(root, a); else inline(); })
        .catch(inline);
    } else {
      inline();
    }
  }

  function setup(root, artists) {
    var PAGE_SIZE = parseInt(root.getAttribute('data-page-size'), 10) || DEFAULT_PAGE_SIZE;

    // Nom de famille pour le tri A–Z : le champ `nom` de l'index (V2 — la source que PDA
    // utilise déjà, letter_id == lastname[0] prouvé 3 053/3 053). Repli « dernier mot » =
    // robustesse DONNÉES (entrée sans `nom`) — la devinette seule classait 242/3 125
    // artistes sous la mauvaise lettre (« DE MARE » sous M, « LA GIRAUDIERE » sous G).
    artists.forEach(function (a) {
      if (a.nom) { a._lastname = String(a.nom).toLowerCase(); return; }
      var words = (a.name || '').trim().split(/\s+/);
      a._lastname = (words[words.length - 1] || '').toLowerCase();
    });

    /* ⛔ L'INDEX SERVI, CAPTURÉ AVANT TOUT FILTRE. La disponibilité d'un tri est une
     * propriété de la DONNÉE SERVIE, jamais du sous-ensemble affiché : `artists` est
     * réassigné juste en dessous par le pré-filtre /search, et le garde `filtrerTrisDispo`
     * recevait donc une liste déjà rétrécie. Sur une recherche qui ne matche aucun artiste
     * (« paysage », « nature morte », « composition »… le cas nominal dès qu'on cherche un
     * titre d'œuvre), il recevait une liste VIDE, sortait sans rien faire, et les DEUX
     * verrous sautaient d'un coup : les 2 options « Ajout » restaient offertes ET un
     * `?tri=ajout-desc` était accepté — sur un index sans `oid`, donc au hasard. */
    var indexServi = artists;

    // /search : restreint la base aux artistes dont le NOM matche la requête. Le tab
    // Artistes de la recherche réutilise CE catalogue (filtré) → facettes / A–Z / tri /
    // compteurs opèrent ensuite sur ce sous-ensemble. Absent sur /pages/artistes (= pas
    // d'attribut → aucun effet, comportement intact). Compteur dispatché pour les tabs.
    var searchQ = root.getAttribute('data-pda-search-q');
    if (searchQ != null) {
      var nq = normalize(searchQ).trim();
      var toks = nq ? nq.split(/\s+/).filter(function (t) { return t.length >= 3; }) : [];
      if (nq) {
        artists = artists.filter(function (a) {
          var nm = normalize(a.name);
          if (nm.indexOf(nq) !== -1) return true;
          return toks.some(function (t) { return nm.indexOf(t) !== -1; });
        });
      }
      root.dataset.pdaCount = String(artists.length);
      document.dispatchEvent(new CustomEvent('pda:search-artists', { detail: { count: artists.length } }));
    }

    /* ─── Vignettes du carrousel de suggestions (S05 lot E3.e, 07/08) ───────
     *
     * Chaque carte du carrousel mène au groupe d'un badge. Sa vignette vient du
     * champ `image` du badge ; quand Sam ne l'a pas renseignée, on prend l'image
     * du PREMIER ARTISTE du badge (cote Sam).
     *
     * ⛔ POURQUOI ICI ET PAS EN LIQUID — la raison est mesurée, pas de confort.
     * Un metaobject `badge_artiste` ne connaît PAS ses porteurs : la référence
     * est portée par l'artiste (`artiste.badges`), jamais l'inverse. Les trouver
     * exige donc de parcourir les artistes — et
     * `shop.metaobjects.artiste.values` n'itère que 50 fois en Liquid, quelle
     * que soit `limit` (mesuré le 07/08 ; son `.size` annonce pourtant 1 132).
     * Sur un catalogue trié alphabétiquement, ça ne couvre rien de fiable :
     * « Legend » n'avait pas de vignette parce que ses porteurs sont aux rangs
     * ~430 et 836.
     *
     * Ici, `artists` EST l'index complet, déjà téléchargé pour la grille de
     * cette page : les 1 132 artistes avec leurs badges et leur image. Aucune
     * limite, aucune requête de plus, aucun champ à saisir.
     *
     * « Premier » = premier de l'index, qui est ordonné par handle. On ne peut
     * pas faire « premier AJOUTÉ au badge » : rien n'enregistre QUAND un artiste
     * reçoit un badge — ni sur l'artiste, ni sur le badge. */
    (function vignettesDesBadges() {
      var cartes = document.querySelectorAll('.pda-catcard[data-pda-badge]');
      for (var i = 0; i < cartes.length; i++) {
        var carte = cartes[i];
        var hote = carte.querySelector('.pda-catcard__img');
        // Vignette déjà peinte (champ `image` du badge) : la curation gagne.
        if (!hote || hote.querySelector('img')) continue;
        var h = carte.getAttribute('data-pda-badge');
        var src = null, wh = null, alt = '', porteur = false;
        for (var j = 0; j < artists.length; j++) {
          var a = artists[j];
          if (!a.badgeHandles || a.badgeHandles.indexOf(h) === -1) continue;
          porteur = true;
          src = a.img || a.portrait;
          wh = a.img ? a.imgWH : a.portraitWH;
          alt = a.name || '';
          if (src) break; // un porteur sans image ne décide pas pour le groupe
        }
        /* AUCUN PORTEUR ⇒ ON MASQUE LA CARTE ENTIÈRE.
         * Le carrousel liste les BADGES, pas les badges qui ont des artistes :
         * un badge dont on a retiré tous les artistes garderait sa carte, sans
         * vignette, menant à une page « 0 artiste ». Même règle que la facette
         * « Collection », masquée quand elle n'a aucune valeur. */
        if (!porteur) { carte.hidden = true; continue; }
        if (!src) continue; // porteur sans image : carte gardée, sans vignette
        var img = document.createElement('img');
        // loading, sizes et srcset AVANT src : une img détachée télécharge dès que src est posé.
        img.loading = 'lazy';
        var taille = imageALaTaille(src, wh, RATIO_VIGNETTE);
        if (taille) {
          // Cotes fixes du CSS : juste à toute largeur, rotation et redimensionnement compris.
          img.setAttribute('sizes', '(max-width: 767px) ' + Math.ceil(VIGNETTE_M * taille.k) + 'px, ' + Math.ceil(VIGNETTE_D * taille.k) + 'px');
          img.setAttribute('srcset', taille.srcset);
        } else {
          img.setAttribute('sizes', '250px');
        }
        img.alt = alt;
        img.src = src;
        hote.appendChild(img);
      }
    })();

    var state = {
      letter: 'all',
      facets: { nationality: [], movement: [], style: [], techniques: [], badge: [], collection: [] },
      sort: TRI_DEFAUT,
      page: 1
    };

    var grid = root.querySelector('[data-pda-artists-grid]');
    /* Largeur PEINTE d'une case de la grille (auto-fill, elle dépend de la fenêtre et
     * du panneau de filtres : pas exprimable en vw). Mesurée après chaque rendu et à
     * chaque redimensionnement ; `sizes` = case × k de l'image (cf. imageALaTaille). */
    var largeurCaseGrille = 0;
    function mesurerCaseGrille() {
      if (!grid || grid.hidden) return 0;
      var media = grid.querySelector('.pda-card-artist__media');
      return media ? media.getBoundingClientRect().width : 0;
    }
    function ajusterSizes() {
      var l = mesurerCaseGrille();
      if (!(l > 0)) return;
      largeurCaseGrille = l;
      var imgs = grid.querySelectorAll('img[data-pda-k]');
      for (var i = 0; i < imgs.length; i++) {
        var s = sizesPour(l, parseFloat(imgs[i].getAttribute('data-pda-k')));
        if (imgs[i].getAttribute('sizes') !== s) imgs[i].setAttribute('sizes', s);
      }
    }
    if (grid && window.ResizeObserver) new ResizeObserver(ajusterSizes).observe(grid);
    var emptyEl = root.querySelector('[data-pda-empty]');
    var paginationEl = root.querySelector('[data-pda-pagination]');
    var progressEl = root.querySelector('[data-pda-progress]');
    var loadMoreBtn = root.querySelector('[data-pda-load-more]');
    var azBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pda-letter]'));

    // En-tête de page (section voisine pda-collection-header) : titre + compteur
    // pilotés par la sélection active. Une « sélection d'artistes » = /pages/artistes
    // filtré par une carte de suggestion (?badge=oui, ?mouvement=X) — pas une page
    // dédiée (décision Sam 2026-07-01). Le H1 « Découvrez nos artistes » devient le
    // nom de la sélection, et le compteur reflète le sous-ensemble.
    var headerTitleEl = document.querySelector('.pda-collection-header__title');
    var defaultTitle = headerTitleEl ? headerTitleEl.textContent.trim() : '';
    // Libellés de sélection (clé « param:valeur » → titre). Émis par le Liquid pour
    // les cas spéciaux (badge) ; les mouvements se nomment d'eux-mêmes (valeur = libellé).
    SELECTION_TITLES = {};
    var stEl = root.querySelector('[data-pda-selection-titles]');
    if (stEl) { try { SELECTION_TITLES = JSON.parse(stEl.textContent) || {}; } catch (e) {} }

    // Valeurs possibles par facette (pré-calcul, triées alpha).
    /* Valeurs d'un artiste pour une facette : `collection` passe par
     * `autresBadges` (exclusion du badge à part), les autres lisent leur clé. */
    function valeursDe(a, k) {
      if (k === 'collection') return autresBadges(a);
      return a[SOURCE_KEY[k] || k] || [];
    }

    var ALL_VALUES = {};
    LIST_KEYS.forEach(function (k) {
      var set = {};
      artists.forEach(function (a) { valeursDe(a, k).forEach(function (v) { set[v] = true; }); });
      ALL_VALUES[k] = Object.keys(set).sort(function (a, b) { return a.localeCompare(b, 'fr'); });
    });

    /* Handle de badge → nom FR, apparié depuis l'index — MÊMES paires que
     * `autresBadges`, même exclusion du badge à part.
     *
     * À quoi ça sert : depuis le 27/08 le Liquid émet `?collection=<handle>` et non
     * plus `?collection=<nom>`, parce que le nom est TRADUIT par Shopify hors FR et
     * que le filtrage, lui, se fait sur les valeurs FRANÇAISES de l'index. Cette
     * table ramène le handle vers le nom FR juste avant la validation.
     *
     * ⛔ MÊME GARDE QUE `autresBadges` : sans `badgeHandles` appariés (skew de
     * déploiement — un index publié avant le lot E3.e porte `badges` mais pas
     * `badgeHandles`), on ne remplit RIEN. La table reste vide, seule l'ancienne
     * forme (nom FR) résout, et le filtre dégrade au lieu de casser. */
    var HANDLE_VERS_NOM = {};
    artists.forEach(function (a) {
      var noms = a.badges || [];
      var handles = a.badgeHandles;
      if (!handles || handles.length !== noms.length) return;
      for (var i = 0; i < noms.length; i++) {
        if (handles[i] !== BADGE_A_PART) HANDLE_VERS_NOM[handles[i]] = noms[i];
      }
    });

    // =====================================================================
    //  Rendu d'une card (miroir de snippets/pda-card-artist.liquid : même œuvre ;
    //  le fichier, lui, est servi à la taille de la case ici, en original là-bas)
    // =====================================================================
    function cardHTML(a) {
      // Image : portrait si présent, sinon 1re œuvre de l'artiste (a.img, fallback Sam
      // 2026-06-18 — les portraits ne sont pas migrés), sinon placeholder crème.
      var imgSrc = a.portrait || a.img;
      var taille = imageALaTaille(imgSrc, a.portrait ? a.portraitWH : a.imgWH, RATIO_CARTE);
      var media = imgSrc
        ? '<img src="' + escapeAttr(imgSrc) + '"' +
          (taille ? ' srcset="' + escapeAttr(taille.srcset) + '" sizes="' + escapeAttr(sizesPour(largeurCaseGrille, taille.k)) + '" data-pda-k="' + taille.k + '"' : '') +
          ' alt="' + escapeAttr(a.name || '') + '" loading="lazy" width="480" height="554">'
        : '<span class="pda-card-artist__placeholder" aria-hidden="true"></span>';
      // Sous-titre = nationalité SEULE (décision Sam 2026-07-01) ; masqué si absente.
      var country = (a.nationality && a.nationality[0]) || '';
      if (country) country = labelLocalise('nationality', country) || country;
      var occLine = country
        ? '<span class="pda-card-artist__occupation">' + escapeHtml(country) + '</span>'
        : '';
      return '<div class="pda-cat__card-wrap" data-pda-card>' +
        '<a class="pda-card-artist" href="' + escapeAttr(urlLocalisee(a.url) || '#') + '" data-letter="' + escapeAttr(a.letter || '') + '" data-handle="' + escapeAttr(a.handle || '') + '">' +
          '<div class="pda-card-artist__media">' + media + '</div>' +
          '<div class="pda-card-artist__content">' +
            '<span class="pda-card-artist__top"><span class="pda-card-artist__name">' + escapeHtml(a.name || '') + '</span>' + ARROW_SVG + '</span>' +
            occLine +
          '</div>' +
        '</a></div>';
    }

    // =====================================================================
    //  URL ↔ état
    // =====================================================================
    /* ⛔ LE TRI ARTISTES A SON PROPRE PARAMÈTRE (`tri_artistes`), décision Sam 12/08.
     * Il s'appelait `tri` — le MÊME nom que le tri des ŒUVRES. Sur /search, où les DEUX
     * catalogues sont rendus, les deux moteurs écrivaient et lisaient donc la même clé
     * d'URL. Ça ne cassait rien uniquement parce que les deux jeux de valeurs sont
     * DISJOINTS : chacun rejetait la valeur de l'autre et retombait sur son défaut.
     * C'est une propriété fragile, pas une conception — aligner un jour les tris œuvres
     * sur le back-office (la suite naturelle de la cote « même texte que le back ») aurait
     * rendu les valeurs communes, et les deux moteurs se seraient écrasés mutuellement.
     * Désamorcé AVANT cet alignement, pas après. */
    var PARAM = {
      letter: 'lettre', nationality: 'nationalite', movement: 'mouvement',
      style: 'style', techniques: 'technique', badge: 'badge', collection: 'collection',
      sort: 'tri_artistes'
    };

    /* Ancienne clé, conservée en LECTURE SEULE pour les liens déjà partagés (`?tri=za`
     * circule dans des favoris). ⚠️ Elle n'est honorée QUE sur une page sans catalogue
     * œuvres : là où le menu œuvres existe, `tri` lui appartient, et le lire ici
     * recréerait exactement l'ambiguïté qu'on supprime. Le marqueur de périmètre posé sur
     * son menu est ce qui permet de trancher à qui la clé appartient. */
    var PARAM_SORT_LEGACY = 'tri';
    function triLegacyLisible() {
      return !document.querySelector('[data-pda-sort-scope="oeuvres"]');
    }

    // F10 (audit 2026-07-07) : alignement sur le pattern du catalogue œuvres —
    // valeurs d'URL VALIDÉES contre la data réelle (une valeur morte restait en
    // chip fantôme + 0 résultat sans signal), pushState par action utilisateur
    // (back/forward naviguent les états de filtre) + handler popstate.
    var urlReady = false; // true après le boot → writeUrl pousse une entrée
    var lastQs = '';      // dernière query posée (ignore les popstate étrangers)

    function readUrl() {
      var p = new URLSearchParams(window.location.search);
      if (p.has(PARAM.letter)) {
        var l = p.get(PARAM.letter);
        state.letter = (l === 'all' || /^[A-Z]$/.test(l)) ? l : 'all';
      }
      FACET_KEYS.forEach(function (k) {
        if (!p.has(PARAM[k])) return;
        var vals = p.get(PARAM[k]).split('|').filter(Boolean);
        var kept = [];
        var rejetes = [];
        vals.forEach(function (v) {
          // `badge` = booléen (le badge à part) : seule la valeur « oui » a un sens.
          if (k === 'badge') { if (v === 'oui') kept.push(v); else rejetes.push(v); return; }
          /* ⚠️ COMPATIBILITÉ DES DEUX FORMES — même régime que `az`/`za` du tri.
           * Le Liquid émet désormais le HANDLE ; le nom FR circule encore dans les
           * liens déjà partagés, les favoris et l'indexation. On résout le handle
           * vers son nom FR, on laisse passer le nom tel quel, et le filtrage reste
           * sur les valeurs FRANÇAISES de l'index — l'invariant du lot 4 est intact.
           * Un jeton TRADUIT (`Angesagte Künstler`) n'est toujours pas accepté : c'est
           * précisément lui qui faisait tomber le filtre, il doit rester rejeté et
           * SIGNALÉ, pas rattrapé en silence. */
          var val = (k === 'collection' && HANDLE_VERS_NOM[v]) ? HANDLE_VERS_NOM[v] : v;
          if (ALL_VALUES[k] && ALL_VALUES[k].indexOf(val) !== -1) kept.push(val);
          else rejetes.push(v);
        });
        if (rejetes.length) {
          // On signale le jeton D'ORIGINE, pas sa résolution : c'est celui qui est dans l'URL.
          console.warn('[pda-artistes] valeur(s) URL inconnue(s) ignorée(s) — ' + PARAM[k] + ' : '
            + rejetes.join(', '));
        }
        state.facets[k] = kept;
      });
      // Nouvelle clé d'abord ; l'ancienne ne sert de repli QUE si elle nous appartient.
      var brutTri = p.has(PARAM.sort) ? p.get(PARAM.sort)
        : (triLegacyLisible() && p.has(PARAM_SORT_LEGACY) ? p.get(PARAM_SORT_LEGACY) : null);
      if (brutTri !== null) {
        var s = brutTri;
        /* Whitelist stricte (anti-forge). ⚠️ COMPATIBILITÉ DES ANCIENS LIENS : `az`/`za`
         * circulent dans des URL partagées et des favoris — ils sont TRADUITS, pas ignorés.
         * `count` (« Plus d'œuvres », retiré) retombe silencieusement sur le défaut : l'option
         * n'existe plus, mais un vieux lien ne doit pas casser la page. */
        var ALIAS = new Map([['az', 'alpha-asc'], ['za', 'alpha-desc']]);
        if (ALIAS.has(s)) s = ALIAS.get(s);
        if (TRIS_VALIDES.has(s) && !(oidAbsent && TRI_OID.has(s))) state.sort = s;
      }
    }

    function writeUrl() {
      var p = new URLSearchParams(window.location.search);
      Object.keys(PARAM).forEach(function (k) { p.delete(PARAM[k]); }); // préserve les autres params
      /* L'ancienne clé est NETTOYÉE — mais seulement là où elle nous appartient. Sans ça, un
       * lien `?tri=za` laisserait traîner `?tri=za&tri_artistes=alpha-desc`, deux clés qui
       * disent la même chose. Et sur /search, ce `delete` effacerait le tri des ŒUVRES. */
      if (triLegacyLisible()) p.delete(PARAM_SORT_LEGACY);
      if (state.letter && state.letter !== 'all') p.set(PARAM.letter, state.letter);
      FACET_KEYS.forEach(function (k) {
        if (state.facets[k].length) p.set(PARAM[k], state.facets[k].join('|'));
      });
      if (state.sort && state.sort !== TRI_DEFAUT) p.set(PARAM.sort, state.sort);
      var qs = p.toString();
      var url = window.location.pathname + (qs ? '?' + qs : '');
      try {
        if (urlReady) window.history.pushState(null, '', url);
        else window.history.replaceState(null, '', url);
      } catch (e) {}
      lastQs = qs;
    }

    function onPopState() {
      var cur = window.location.search.replace(/^\?/, '');
      if (cur === lastQs) return; // popstate étranger (cart-drawer…) : rien à faire
      state.letter = 'all';
      FACET_KEYS.forEach(function (k) { state.facets[k] = []; });
      state.sort = TRI_DEFAUT;
      state.page = 1;
      readUrl();
      syncSortUI();
      render();
      lastQs = cur;
    }

    function syncSortUI() {
      root.querySelectorAll('.pda-dropdown__option[data-pda-sort]').forEach(function (b) {
        var on = b.getAttribute('data-pda-sort') === state.sort;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    // =====================================================================
    //  Filtrage / tri
    // =====================================================================
    function matchFacet(artist, key, selected) {
      if (!selected.length) return true;
      // Le badge à part est un BOOLÉEN : la valeur sélectionnée ne sert qu'à
      // dire « filtre actif », comme `facets.ex` côté œuvres.
      if (key === 'badge') return artist.badge === true;
      var vals = valeursDe(artist, key);
      return selected.some(function (s) { return vals.indexOf(s) !== -1; }); // OR intra-facette
    }

    function filterArtists(exceptKey) {
      return artists.filter(function (a) {
        if (state.letter !== 'all' && a.letter !== state.letter) return false;
        for (var i = 0; i < FACET_KEYS.length; i++) {
          var k = FACET_KEYS[i];
          if (k === exceptKey) continue;
          if (!matchFacet(a, k, state.facets[k])) return false;
        }
        return true;
      });
    }

    /* FIX-5 (12/08) — LES 6 TRIS DU BACK-OFFICE, avec SES comparateurs.
     *
     * ⛔ LE TIEBREAK N'EST PAS UN DÉTAIL. `added` est le `createdAt` à la SECONDE et les lots
     * de migration créent les metaobjects par paquets : mesuré sur l'index servi, **94 valeurs
     * distinctes pour 1 132 artistes — 1 130 sur 1 132 sont dans un paquet d'ex æquo**. Sans
     * départage, « Ajout récents » rendrait un ordre ARBITRAIRE sur 99,8 % du catalogue :
     * visuellement plausible, factuellement faux, et DIFFÉRENT de ce que le BO montre pour le
     * même tri. Le BO départage par l'id numérique du GID ; l'index publie désormais cette
     * valeur sous `oid` (cf. `app/lib/pda/index-build/types.ts`), monotone à la création.
     *
     * ⚠️ DÉGRADATION HONNÊTE : si l'index servi est ANTÉRIEUR au déploiement de l'app, `oid`
     * est absent — les 2 options « Ajout » sont alors RETIRÉES du menu (cf. `filtrerTrisDispo`)
     * plutôt que de rendre un ordre faux. « Je ne sais pas » ne s'affiche pas comme un tri.
     *
     * Nulls de `birth` : mêmes conventions que le BO (`?? 9999` en croissant, `?? 0` en
     * décroissant) — un artiste sans date de naissance va en fin dans les deux sens.
     * ⚠️ Collation : la vitrine trie sur `nom` seul avec locale 'fr', le BO sur
     * `norm(nom) + " " + norm(name)` SANS locale. **45 artistes portent un nom de famille en
     * doublon** (22 doublons mesurés) : sur ceux-là les deux listes peuvent diverger. Écart
     * connu, non résolu — à harmoniser si la parité stricte devient un critère. */
    function oidDe(a) { return typeof a.oid === 'number' ? a.oid : 0; }
    /* ⛔ L'ASYMÉTRIE EST LE MÉCANISME, PAS UN TIC DE STYLE — conventions du BO.
     * « Sans date de naissance ⇒ EN FIN dans les DEUX sens » ne s'obtient qu'en envoyant les
     * nulls à l'extrémité OPPOSÉE selon le sens : 0 en décroissant (le plus petit finit
     * dernier), 9999 en croissant (le plus grand finit dernier). Les unifier sur une seule
     * valeur — ce que j'ai fait un instant en « nettoyant » — remonte les 10 artistes sans
     * date EN TÊTE du tri décroissant, sans erreur et sans que la liste paraisse anormale. */
    function naissanceFin(a, decroissant) {
      if (a.birth != null) return a.birth;
      return decroissant ? 0 : 9999;
    }

    /* ⛔ UNE TABLE, PAS UNE CHAÎNE DE `else if`. La chaîne finissait par un `else` qui servait
     * DEUX rôles à la fois : « alpha-asc » et « clé inconnue ». `alpha-asc` n'y était jamais
     * nommé, donc le comparateur par défaut ne suivait pas `TRI_DEFAUT` — changer la constante
     * aurait marqué une option dans le menu et rendu l'ordre d'une autre, sans rien casser
     * visiblement. Ici chaque clé nomme son comparateur, et le défaut se RÉSOUT par
     * `TRI_DEFAUT` : les deux ne peuvent plus diverger.
     * ⚠️ Les clés de cette table doivent couvrir `TRIS_VALIDES` — une clé validée sans
     * comparateur retomberait silencieusement sur le défaut, c'est-à-dire trierait autre chose
     * que ce que le menu affiche. */
    var COMPARATEURS = {
      'alpha-asc':      function (a, b) { return a._lastname.localeCompare(b._lastname, 'fr'); },
      'alpha-desc':     function (a, b) { return b._lastname.localeCompare(a._lastname, 'fr'); },
      // `added` est à la seconde et la migration crée par paquets : le départage par `oid`
      // n'est pas cosmétique, il porte l'ordre de 1 130 artistes sur 1 132 (cf. ci-dessus).
      'ajout-desc':     function (a, b) {
        return String(b.added || '').localeCompare(String(a.added || '')) || oidDe(b) - oidDe(a);
      },
      'ajout-asc':      function (a, b) {
        return String(a.added || '').localeCompare(String(b.added || '')) || oidDe(a) - oidDe(b);
      },
      // Sans date de naissance ⇒ en FIN dans les deux sens (cf. `naissanceFin`).
      'naissance-desc': function (a, b) { return naissanceFin(b, true) - naissanceFin(a, true); },
      'naissance-asc':  function (a, b) { return naissanceFin(a, false) - naissanceFin(b, false); },
    };

    function sortArtists(list) {
      var arr = list.slice();
      var cmp = COMPARATEURS[state.sort] || COMPARATEURS[TRI_DEFAUT];
      arr.sort(cmp);
      return arr;
    }

    /* Retire du menu les tris que la DONNÉE SERVIE ne permet pas d'honorer. Aujourd'hui un
     * seul cas : `oid` absent d'un index publié avant le déploiement de l'app. Mieux vaut une
     * option en moins qu'une option qui ment. */
    function filtrerTrisDispo(artistes) {
      /* ⛔ ÉCHEC EN POSITION FERMÉE. La condition est écrite dans le sens « je ne retire
       * RIEN que si je peux PROUVER que la donnée est là » : liste vide, liste absente ou
       * une seule entrée sans `oid` ⇒ on retire. La version précédente sortait sur liste
       * vide en laissant `oidAbsent` à false, c'est-à-dire qu'elle traitait « je ne sais
       * pas » comme « tout va bien ». `every` et pas `some` : un index à moitié pourvu
       * trierait juste une partie du catalogue, ce qui est pire qu'un tri en moins. */
      var dispo = !!artistes && artistes.length > 0 && artistes.every(function (a) {
        return typeof a.oid === 'number';
      });
      if (dispo) return;
      oidAbsent = true;
      /* Scopé à `root`, comme `syncSortUI` et `setSort`. En `document`, cette boucle voyait
       * les 14 boutons des DEUX menus de /search : inoffensif tant que `TRI_OID` n'intersecte
       * pas les clés œuvres, mais le menu œuvres appelle DÉJÀ `oldest` « Ajout anciens » —
       * le jour où ses clés sont alignées sur le BO, ce garde masquerait en silence des
       * options qui ne lui appartiennent pas. */
      var menu = root.querySelectorAll('.pda-dropdown__option[data-pda-sort]');
      for (var i = 0; i < menu.length; i++) {
        if (TRI_OID.has(menu[i].getAttribute('data-pda-sort'))) menu[i].hidden = true;
      }
      /* Filet, pas la protection principale : au seul site d'appel `state.sort` vaut encore
       * TRI_DEFAUT (on est AVANT `readUrl`). C'est la whitelist qui refuse `?tri=ajout-desc`.
       * ⚠️ Ne pas « simplifier » en déplaçant cet appel après `readUrl()` : le verrou d'URL
       * deviendrait alors inerte, `oidAbsent` valant encore false quand la whitelist statue. */
      if (TRI_OID.has(state.sort)) state.sort = TRI_DEFAUT;
    }

    // =====================================================================
    //  Rendu de la grille (client-side depuis l'index)
    // =====================================================================
    // Titre de sélection : la page filtrée par UNE carte de suggestion (badge=oui OU
    // un seul mouvement, sans autre filtre ni lettre) affiche le nom de la sélection
    // en H1 ; sinon le titre par défaut. Réactif : retirer le filtre rend le défaut.
    function selectionTitle() {
      if (state.letter !== 'all') return null;
      var f = state.facets;
      var nOther = f.nationality.length + f.style.length + f.techniques.length;
      /* UNE sélection = UN seul filtre actif. Le compte ci-dessous inclut
       * `collection` : sans ça, « Artistes célèbres + un groupe » aurait affiché
       * le titre de l'un des deux, en mentant sur ce qui est réellement filtré. */
      var nBadge = f.badge.length ? 1 : 0;
      if (nBadge && f.movement.length === 0 && f.collection.length === 0 && nOther === 0) {
        return libelleBadgeAPart();
      }
      /* GROUPE PAR BADGE (lot E3.e) — le titre EST le nom du badge. C'est tout
       * l'intérêt de l'arbitrage « renommer le badge au pluriel » : plus aucune
       * table de correspondance à tenir, un badge créé au BO se nomme lui-même
       * sur les 3 surfaces. Rien à ajouter au code pour un 2e badge. */
      if (f.collection.length === 1 && nBadge === 0 && f.movement.length === 0 && nOther === 0) {
        return labelLocalise('collection', f.collection[0]) || f.collection[0];
      }
      if (f.movement.length === 1 && nBadge === 0 && f.collection.length === 0 && nOther === 0) {
        return SELECTION_TITLES['mouvement:' + f.movement[0]] || labelLocalise('movement', f.movement[0]) || f.movement[0];
      }
      return null;
    }

    function render() {
      var matched = sortArtists(filterArtists());
      var visibleCount = Math.min(state.page * PAGE_SIZE, matched.length);

      if (grid) {
        var html = '';
        for (var i = 0; i < visibleCount; i++) html += cardHTML(matched[i]);
        grid.innerHTML = html;
      }

      var isEmpty = matched.length === 0;
      if (emptyEl) emptyEl.hidden = !isEmpty;
      if (grid) grid.hidden = isEmpty;

      /* ⛔ LA PHRASE ENTIÈRE ET LE MÊME FORMAT QUE L'EN-TÊTE. Ces deux lignes écrivaient
       * les nombres BRUTS dans deux <span> séparés, à quelques pixels d'un en-tête que le
       * commit précédent avait passé à `PDA.nombre` : « 2 804 » au-dessus, « 2804 » en
       * dessous, sur le même écran, visible en français sans attendre une traduction.
       * Les nombres partent BRUTS à `trad` — `PDA.t` les met lui-même au format de la
       * locale, et a besoin du nombre pour choisir la forme plurielle. */
      var pagerCountEl = root.querySelector('[data-pda-artistes-pager-count]');
      if (pagerCountEl) {
        pagerCountEl.textContent = trad('pda.artistes.pager.vu', {
          count: visibleCount, vus: visibleCount, total: matched.length,
        });
      }
      if (progressEl) progressEl.style.width = (matched.length ? Math.round((visibleCount / matched.length) * 100) : 0) + '%';

      // En-tête dynamique : H1 = nom de la sélection (sinon défaut) + compteur live
      // dans [data-pda-result-count] (le SSR pose le total 2789 ; on l'aligne sur le
      // sous-ensemble réellement affiché — calque le moteur d'œuvres).
      if (headerTitleEl) headerTitleEl.textContent = selectionTitle() || defaultTitle;
      /* ⛔ MÊME FORMAT QUE LE MOTEUR D'ŒUVRES. `[data-pda-result-count]` est écrit par
       * les DEUX moteurs — et sur /search ils tournent tous les deux. Un `fr-FR` figé
       * ici contre `PDA.nombre` là donnait deux formats sur le même élément selon qui
       * écrivait en dernier : invisible en français, « 1 132 » vs « 1.132 » en allemand. */
      var headerCount = window.PDA && PDA.nombre ? PDA.nombre(matched.length) : String(matched.length);
      document.querySelectorAll('[data-pda-result-count]').forEach(function (el) { el.textContent = headerCount; });
      /* ⛔ LE LIBELLÉ SUIT LE NOMBRE. Ce moteur ne réécrivait QUE le nombre : le mot restait
       * celui du rendu initial, donc « 1 artistes » dès qu'un filtre ne laissait qu'un
       * résultat — en français, sur la page artistes. Hook scopé « artistes » pour que le
       * moteur d'œuvres, qui tourne aussi sur /search, ne vienne pas écrire « oeuvre ». */
      var nomArtistes = trad('pda.artistes.artiste_nom', { count: matched.length });
      document.querySelectorAll('[data-pda-count-label="artistes"]').forEach(function (el) { el.textContent = nomArtistes; });
      var allShown = visibleCount >= matched.length;
      if (paginationEl) paginationEl.hidden = isEmpty;
      if (loadMoreBtn) loadMoreBtn.hidden = allShown;
      /* ⛔ LE LIBELLÉ MENTAIT. Le SSR écrit « Voir 48 de + » et le JS ne l'a JAMAIS mis à
       * jour : il annonçait 48 même quand il restait 12 artistes. Même clé et même calcul
       * que le pager d'œuvres, qui, lui, le faisait déjà. */
      var nextLabelEl = root.querySelector('[data-pda-artistes-next-label]');
      if (nextLabelEl && !allShown) {
        nextLabelEl.textContent = trad('pda.catalogue.pager.suite', {
          count: Math.min(PAGE_SIZE, matched.length - visibleCount),
        });
      }

      hydrateFacets();
      updateCarrouselSuggestions();
      updateHeroBack();
      reflectToggle();
      renderActiveChips();
      updateAzAvailability();
      /* EN DERNIER : une seule mise en page forcée, après toutes les écritures du rendu.
       * Même tâche que l'insertion : les images (lazy) n'ont encore choisi aucun fichier. */
      if (grid && !grid.hidden) ajusterSizes();
    }

    // =====================================================================
    //  Compteurs + hydratation des facettes (markup checkbox 3B)
    // =====================================================================
    function facetCountsFor(key) {
      var base = filterArtists(key); // tout sauf la facette en cours
      var counts = {};
      /* ⛔ `valeursDe`, PAS `a[key]` — bug vécu au 1er badge réel (07/08). La
       * clé `collection` n'existe pas dans l'index (sa donnée est `badges`
       * filtrée) : `a['collection']` rendait undefined, donc TOUS les compteurs
       * à 0, donc `facetLi` masquait chaque option (`count === 0 && !checked`
       * ⇒ hidden). Résultat : la facette apparaissait mais se dépliait VIDE —
       * le groupe n'était plus masqué, ses options l'étaient. Trois fonctions
       * lisent cette donnée (ALL_VALUES, matchFacet, ici) : les trois doivent
       * passer par le même accès, sinon la facette ment sur une seule d'entre
       * elles. */
      base.forEach(function (a) { valeursDe(a, key).forEach(function (v) { counts[v] = (counts[v] || 0) + 1; }); });
      return counts;
    }

    function facetLi(key, value, label, count, checked) {
      var id = 'pdaaf-' + (++uid);
      return '<li class="facets__inputs-list-item" data-code="' + escapeAttr(value) + '"' + (count === 0 && !checked ? ' hidden' : '') + '>' +
        '<div class="checkbox"><input type="checkbox" id="' + id + '" class="checkbox__input" data-pda-facet="' + escapeAttr(key) + '" value="' + escapeAttr(value) + '"' + (checked ? ' checked' : '') + '>' +
        '<label class="checkbox__label" for="' + id + '">' + CHECK_SVG + '<span class="checkbox__label-text">' + escapeHtml(label) + '</span></label></div>' +
        '<span class="pda-facet-count">' + count + '</span></li>';
    }

    // Remplit TOUS les [data-pda-facet-body] (sidebar + quick-pills) d'une clé.
    function hydrateFacets() {
      LIST_KEYS.forEach(function (key) {
        var counts = facetCountsFor(key);
        var selected = state.facets[key];
        var html = ALL_VALUES[key].map(function (val) {
          return facetLi(key, val, labelLocalise(key, val) || prettyLabel(val), counts[val] || 0, selected.indexOf(val) !== -1);
        }).join('');
        root.querySelectorAll('[data-pda-facet-body][data-facet-key="' + key + '"]').forEach(function (body) {
          body.innerHTML = html;
          // Au-delà de FACET_OVERFLOW_LIMIT options : recherche + repli « Voir plus »
          // (présentation, pda-facets.js).
          if (window.PdaFacets) window.PdaFacets.applyFacetOverflow(body);
        });
        /* ⛔ GROUPE SANS AUCUNE OPTION = GROUPE MASQUÉ.
         *
         * C'est LE bloquant vécu le 06/08 côté œuvres, à l'identique : la
         * facette « Collection » y restait VISIBLE ET VIDE sur toute collection
         * seedée, et une vérif pixel à 39/39 ids ne l'avait pas vu — elle
         * mesurait la seule page où la valeur existait. Ici le cas est même
         * NOMINAL, pas limite : tant que « Artistes célèbres » est le seul
         * badge, il est le badge à part, donc `ALL_VALUES.collection` est VIDE.
         * Sans cette ligne, l'accordéon « Collection » serait vide dès le
         * déploiement, sur toutes les pages.
         *
         * On masque le CONTENEUR de facette (l'accordéon entier), pas la liste :
         * masquer la liste laisserait un titre cliquable qui n'ouvre rien. */
        var vide = ALL_VALUES[key].length === 0;
        root.querySelectorAll('[data-pda-facet-body][data-facet-key="' + key + '"]').forEach(function (b) {
          var hote = b.closest('[data-filter-param-name="' + key + '"]') || b.closest('.facets__item');
          if (hote) hote.hidden = vide;
        });
      });
    }

    /* ─── Carrousel de suggestions : cascade quand un groupe est choisi ──────
     *
     * Cote Sam (07/08) : « quand on choisit une liste dans le carrousel, il faut
     * ensuite enlever les suggestions pour les mettre en bas (comme pour les
     * suggestions de collection d'œuvres), et afficher toutes les listes sauf
     * celle déjà sélectionnée. »
     *
     * Même comportement que `updateDrillSuggestions` du catalogue œuvres, et
     * réversible : au retrait du filtre, le carrousel remonte et retrouve toutes
     * ses cartes.
     *
     * ⛔ `display` EN PLUS de `hidden` : `.pda-context-collections` porte un
     * `display:block` À PLAT qui BAT l'attribut `[hidden]` — piège déjà vécu
     * côté œuvres, où le carrousel restait visible chez Sam. */
    var carrousel = document.querySelector('.pda-context-collections');
    var carrouselAncre = null;   // position d'origine, pour pouvoir revenir
    var carrouselBas = null;
    if (carrousel) {
      var sec = carrousel.closest('.shopify-section') || carrousel;
      carrouselAncre = document.createComment('pda-carrousel-artistes');
      sec.parentNode.insertBefore(carrouselAncre, sec);
      carrouselBas = sec;
    }

    /** Nom du groupe actif, ou null si aucun (ou si plusieurs filtres). */
    function groupeActif() {
      var f = state.facets;
      var nOther = f.nationality.length + f.movement.length + f.style.length + f.techniques.length;
      if (nOther || state.letter !== 'all') return null;
      if (f.collection.length === 1 && !f.badge.length) return f.collection[0];
      if (f.badge.indexOf('oui') !== -1 && !f.collection.length) return BADGE_A_PART;
      return null;
    }

    /* Flèche retour du hero — même bouton que le catalogue œuvres
     * (`data-pda-hero-back`, rendu par `pda-collection-header.liquid` et masqué
     * par défaut ici). Elle apparaît dès qu'un groupe est sélectionné et ramène
     * à TOUS les artistes.
     * ⛔ Le `href` SSR pointe `/collections/all` (le retour des ŒUVRES) : on le
     * réécrit, sinon la flèche sortirait le visiteur du catalogue artistes. */
    function updateHeroBack() {
      var back = document.querySelector('[data-pda-hero-back]');
      if (!back) return;
      var actif = groupeActif();
      if (actif) {
        back.href = window.location.pathname;
        back.setAttribute('aria-label', 'Revenir à tous les artistes');
        back.hidden = false;
      } else {
        back.hidden = true;
      }
    }

    function updateCarrouselSuggestions() {
      if (!carrouselBas || !carrouselAncre) return;
      var actif = groupeActif();
      var cartes = carrouselBas.querySelectorAll('.pda-catcard[data-pda-badge]');
      if (actif) {
        // En BAS de la page, après le catalogue.
        var cat = root.closest('.shopify-section') || root;
        if (carrouselBas.previousElementSibling !== cat) cat.parentNode.insertBefore(carrouselBas, cat.nextSibling);
        for (var i = 0; i < cartes.length; i++) {
          var c = cartes[i];
          /* La carte du groupe COURANT sort : on ne propose pas ce qu'on regarde
           * déjà. Comparaison sur le HANDLE pour le badge à part, sur le TITRE
           * pour les autres — c'est ce que porte `state.facets.collection`. */
          /* LOT 4 : la carte SSR rend le titre TRADUIT par Shopify hors fr, mais
           * `actif` (l'état) reste la valeur FRANÇAISE de l'index — on compare donc
           * au libellé LOCALISÉ du groupe (fallback FR : les deux côtés retombent
           * ensemble). groupeActif() reste LOGIQUE : ne jamais traduire sa sortie. */
          var actifAffiche = labelLocalise('collection', actif) || actif;
          var estCourante = (actif === BADGE_A_PART)
            ? c.getAttribute('data-pda-badge') === BADGE_A_PART
            : (c.querySelector('.pda-catcard__title') || {}).textContent === actifAffiche;
          c.style.display = estCourante ? 'none' : '';
        }
      } else {
        // Retour en haut, toutes les cartes rendues.
        if (carrouselAncre.parentNode && carrouselBas.previousSibling !== carrouselAncre) {
          carrouselAncre.parentNode.insertBefore(carrouselBas, carrouselAncre.nextSibling);
        }
        for (var j = 0; j < cartes.length; j++) cartes[j].style.display = '';
      }
    }

    function reflectToggle() {
      var bt = root.querySelector('[data-pda-toggle="badge"]');
      if (bt) bt.checked = state.facets.badge.indexOf('oui') !== -1;
    }

    // ── Chips de filtres sélectionnés (parité catalogue œuvres, Figma 895:35319) ──
    // Mêmes classes (.pda-facets-active*) + même × que pda-catalog.js → skin §16 partagé.
    function chipHTML(c) {
      return '<button type="button" class="pda-facets-active__chip" data-chip-key="' + escapeAttr(c.key) + '" data-chip-value="' + escapeAttr(c.value) + '">' +
        '<span class="pda-facets-active__x">' + CHIP_X_SVG + '</span><span>' + escapeHtml(c.label) + '</span></button>';
    }
    function renderActiveChips() {
      var hosts = root.querySelectorAll('[data-pda-active-chips]');
      if (!hosts.length) return;
      var chips = [];
      // Facettes liste (ordre = manifest) puis badge — valeurs = libellés affichés.
      LIST_KEYS.forEach(function (key) {
        state.facets[key].forEach(function (v) { chips.push({ key: key, value: v, label: labelLocalise(key, v) || prettyLabel(v) }); });
      });
      // Le libellé vient du metaobject (via le Liquid), pas d'un littéral : un badge
      // renommé au BO ou traduit se nomme lui-même sur la chip comme sur le titre.
      if (state.facets.badge.indexOf('oui') !== -1) chips.push({ key: 'badge', value: 'oui', label: libelleBadgeAPart() });
      var html = chips.map(chipHTML).join('') +
        (chips.length ? `<button type="button" class="pda-facets-active__reset" data-pda-reset>${escapeHtml(trad('pda.commun.reinitialiser'))}</button>` : '');
      for (var i = 0; i < hosts.length; i++) { hosts[i].innerHTML = html; hosts[i].hidden = chips.length === 0; }
      updateBarState(chips);
    }

    // ── États de la barre V2 (parité œuvres 14/07 : « • N », dots quick-pills,
    // Réinitialiser barre). La lettre A–Z active compte comme une valeur (dot
    // Alphabétique + incluse dans N — cohérent : Réinitialiser la remet à « # »).
    function updateBarState(chips) {
      var letterActive = state.letter !== 'all';
      var n = chips.length + (letterActive ? 1 : 0);
      root.querySelectorAll('[data-pda-filter-count]').forEach(function (el) {
        el.hidden = n === 0;
        var nEl = el.querySelector('[data-pda-filter-count-n]');
        if (nEl) nEl.textContent = String(n);
      });
      root.querySelectorAll('[data-pda-bar-reset]').forEach(function (el) { el.hidden = n === 0; });
      var activeKeys = {};
      chips.forEach(function (c) { activeKeys[c.key] = true; });
      // « Réinitialiser » DANS le dropdown (modèle app, parité œuvres 22/07 ter).
      root.querySelectorAll('[data-pda-dd-reset]').forEach(function (el) {
        el.hidden = !activeKeys[el.getAttribute('data-facet-key')];
      });
      root.querySelectorAll('[data-quick-pill]').forEach(function (pill) {
        var dot = pill.querySelector('[data-pda-quick-dot]');
        if (!dot) return;
        var key = pill.getAttribute('data-quick-pill');
        dot.hidden = key === 'alphabet' ? !letterActive : !activeKeys[key];
      });
    }

    // =====================================================================
    //  A–Z : désactive les lettres sans résultat dans la sélection courante
    // =====================================================================
    function updateAzAvailability() {
      var saved = state.letter;
      state.letter = 'all';
      var pool = filterArtists();
      state.letter = saved;
      var present = {};
      pool.forEach(function (a) { if (a.letter) present[a.letter] = true; });
      azBtns.forEach(function (btn) {
        var l = btn.getAttribute('data-pda-letter');
        var isActive = l === state.letter;
        btn.setAttribute('data-active', isActive ? 'true' : 'false');
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (l === 'all') return;
        var available = present[l] === true;
        btn.setAttribute('data-disabled', available || isActive ? 'false' : 'true');
      });
    }

    // =====================================================================
    //  Mutations d'état
    // =====================================================================
    function setLetter(letter) {
      state.letter = state.letter === letter ? 'all' : letter;
      state.page = 1; writeUrl(); render();
    }
    function toggleFacet(key, val, on) {
      var arr = state.facets[key];
      var idx = arr.indexOf(val);
      if (on && idx === -1) arr.push(val);
      else if (!on && idx !== -1) arr.splice(idx, 1);
      state.page = 1; writeUrl(); render();
    }
    function setSort(sort) {
      state.sort = sort;
      state.page = 1;
      root.querySelectorAll('.pda-dropdown__option[data-pda-sort]').forEach(function (b) {
        var on = b.getAttribute('data-pda-sort') === sort;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      writeUrl(); render();
    }
    function clearAll() {
      state.letter = 'all';
      FACET_KEYS.forEach(function (k) { state.facets[k] = []; });
      state.page = 1; writeUrl(); render();
    }

    // =====================================================================
    //  Écouteurs délégués (le chrome — ouvrir/fermer, dropdowns — = pda-facets.js)
    // =====================================================================
    // Checkboxes de facettes (hydratées dynamiquement) + toggle badge.
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches('input[data-pda-facet]')) { toggleFacet(t.getAttribute('data-pda-facet'), t.value, t.checked); return; }
      if (t.matches('input[data-pda-toggle="badge"]')) { toggleFacet('badge', 'oui', t.checked); return; }
    });

    // Recherche-dans-facette : filtre les <li> du body de la même facette par texte.
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (!(t instanceof Element) || !t.closest('.pda-facet-search')) return;
      var scope = t.closest('.pda-dropdown__menu--facet, .facets__panel-content, accordion-custom-component');
      var body = scope && scope.querySelector('[data-pda-facet-body]');
      if (!body) return;
      var q = normalize(t.value.trim());
      body.querySelectorAll('.facets__inputs-list-item').forEach(function (li) {
        var label = li.querySelector('.checkbox__label-text');
        var txt = normalize((label || li).textContent || '');
        li.classList.toggle('pda-search-hidden', q.length > 0 && txt.indexOf(q) === -1);
      });
      // En recherche : montre les correspondances + masque « Voir plus » ; vide : repli.
      if (window.PdaFacets) window.PdaFacets.applyFacetOverflow(body);
    });

    // Tri (dropdown 3B) + réinitialiser, par délégation.
    root.addEventListener('click', function (e) {
      var t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      // Chip × (filtre sélectionné) : retire la valeur (décoche l'input + maj state + refresh).
      var chip = t.closest('.pda-facets-active__chip');
      if (chip) { toggleFacet(chip.getAttribute('data-chip-key'), chip.getAttribute('data-chip-value'), false); return; }
      // « Voir plus / Voir moins » : bascule du repli (seuil = FACET_OVERFLOW_LIMIT,
      // présentation, pda-facets.js).
      var moreBtn = t.closest('.pda-facet-more');
      if (moreBtn) { if (window.PdaFacets) window.PdaFacets.toggleFacetOverflow(moreBtn); return; }
      var opt = t.closest('.pda-dropdown__option[data-pda-sort]');
      if (opt) {
        setSort(opt.getAttribute('data-pda-sort'));
        var dd = opt.closest('details.pda-dropdown');
        if (dd) dd.open = false;
        return;
      }
      // « Réinitialiser » d'un dropdown de quick-pill : clear de la SEULE clé du panneau.
      var ddReset = t.closest('[data-pda-dd-reset]');
      if (ddReset) {
        var dk = ddReset.getAttribute('data-facet-key');
        if (dk && state.facets[dk]) state.facets[dk] = [];
        state.page = 1; writeUrl(); render();
        return;
      }
      if (t.closest('[data-pda-reset]')) { clearAll(); return; }
    });

    // A–Z.
    azBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { setLetter(btn.getAttribute('data-pda-letter')); });
    });

    // Pagination.
    if (loadMoreBtn) loadMoreBtn.addEventListener('click', function () { state.page += 1; render(); });

    // =====================================================================
    //  Boot
    // =====================================================================
    /* FIX-5 — retirer du menu les tris que la donnée servie ne permet pas d'honorer, AVANT de
     * lire l'URL : un `?tri=ajout-desc` sur un index sans `oid` doit retomber sur le défaut
     * plutôt que de trier au hasard 1 130 artistes sur 1 132.
     * ⚠️ ICI, au BOOT, et nulle part ailleurs. Deux erreurs de placement successives sur cette
     * seule ligne : d'abord avant que `state` et les tables de constantes n'existent (`var`
     * hoiste la déclaration, pas l'affectation), puis dans le handler de retour navigateur —
     * il y a DEUX `readUrl()` dans ce fichier et le premier n'est pas celui du démarrage.
     * Dans les deux cas le garde était inerte, sans la moindre erreur en console. */
    filtrerTrisDispo(indexServi);
    readUrl();
    syncSortUI();
    render();
    // F10 : back/forward restaurent l'état de filtre (l'URL a pu être normalisée
    // au boot — valeurs mortes retirées — sans entrée d'historique : writeUrl en
    // mode replace tant que urlReady est faux).
    writeUrl();
    urlReady = true;
    window.addEventListener('popstate', onPopState);
  }

  function boot() {
    document.querySelectorAll('[data-pda-artists-catalog]').forEach(init);
  }

  // Filet anti-race d'ordre de chargement : si pda-facets.js (module) s'exécute
  // APRÈS ce script (classic defer), réapplique repli/recherche aux facettes déjà
  // hydratées dès qu'il signale « prêt » (idempotent ; sans effet sinon).
  window.addEventListener('pda:facets-ready', function () {
    if (!window.PdaFacets) return;
    document.querySelectorAll('[data-pda-artists-catalog] [data-pda-facet-body]').forEach(function (b) {
      window.PdaFacets.applyFacetOverflow(b);
    });
  }, { once: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
